import { render } from "./Logo.vue?vue&type=template&id=cf88e72a&ts=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/olaria-preco/olaria-preco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__